import {
  TBillingLineItem,
} from '@commenda/types/src/billing/types';
import { fetcher } from '@commenda/utils';

export interface ICreateCheckoutSessionParams {
  redirectionUrl?: string;
  companyId?: number;
  affiliateFirmId?: string;
  billingAddress?: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: string;
    postalCode: string;
    state: string;
  };
  metadata?: Record<string, any>;
  subscriptionId?: string;
  lineItems: TBillingLineItem[];
}

export async function createCheckoutSession(
  data: ICreateCheckoutSessionParams
) {
  try {
    const res = await fetcher(`billing-new/checkout/session`, {
      method: 'POST',
      body: data,
    });

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
